import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["otherField"]

  toggle(event) {
    if (event.target.value === "Other") {
      this.otherFieldTarget.classList.remove("hidden")
    } else {
      this.otherFieldTarget.classList.add("hidden")
      this.otherFieldTarget.querySelector("input").value = ""
    }
  }
}
